// this file set the global configurations for the whole system
// ----------------- Please configure the settings here --------------------
const backendPort = "5015"

export default {
    backendPort
}
